import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import "./Navbar.css";
import { sideHeaderElements } from "../../data/sideHeader";
import { contact } from "../../data/contact";

const Navbar = ({ activeSection }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);


  const toggleNavbar = () => setIsMobileOpen((prev) => !prev);
  const closeNavbar = () => setIsMobileOpen(false);

  // Close menu on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (isMobileOpen) {
        closeNavbar();
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobileOpen]);

  // Escape key closes menu
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isMobileOpen) {
        closeNavbar();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isMobileOpen]);

  // Close menu on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setIsMobileOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Lock body scroll when menu is open
  useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileOpen]);

  return (
    <nav
      className={`appNavbar ${isMobileOpen ? "mobile-open" : ""}`}
      aria-label="Main navigation"
    >
      <div className="appNavbar__container">
        <a href="#home" className="appNavbar__logo" onClick={closeNavbar}>
          {sideHeaderElements[0].name}
        </a>
        <div className="appNavbar__actions">
          <a
            href={`mailto:${contact.email}`}
            className="appNavbar__whatsapp"
            aria-label="Email Abdellah"
          >
            <FiMail />
          </a>
          <button
            className="appNavbar__toggle"
            onClick={toggleNavbar}
            aria-label="Open menu"
            aria-expanded={isMobileOpen}
            aria-controls="mobile-navigation"
          >
            <FaBars />
          </button>
        </div>
      </div>

      <div
        id="mobile-navigation"
        className={`appNavbar__menu ${isMobileOpen ? "mobile-open" : ""}`}
        aria-hidden={!isMobileOpen}
      >
        <div className="appNavbar__menuHeader">
          <a href="#home" className="appNavbar__menuBrand" onClick={closeNavbar}>
            <span>AK</span>
            <small>Portfolio</small>
          </a>
          <button
            type="button"
            className="appNavbar__close"
            onClick={closeNavbar}
            aria-label="Close menu"
          >
            <FaTimes />
          </button>
        </div>

        <ul className="appNavbar__menuList">
          {sideHeaderElements[1].list.map((element, i) => (
            <li className="appNavbar__item" key={element.link}>
              <a
                className={activeSection === element.link ? "active" : ""}
                href={"#" + element.link}
                onClick={closeNavbar}
                tabIndex={isMobileOpen ? 0 : -1}
              >
                <span className="appNavbar__menuIndex">0{i + 1}</span>
                <span>{element.text}</span>
              </a>
            </li>
          ))}
        </ul>

        <div className="appNavbar__menuFooter">
          <span>Based in Italy</span>
          <a href={`mailto:${contact.email}`} tabIndex={isMobileOpen ? 0 : -1}>
            Discuss a role <FiMail />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
